import React from 'react'
import classNames from 'classnames'
import { Icon } from '@/ui/atoms/Icon'
import { MegaMenuItem } from './types'

type CategoryListProps = {
  item: MegaMenuItem
  hoveredIndex: number | null
  onHover: (index: number) => void
  isMobile: boolean
  activeIndex?: number
}

export const CategoryList: React.FC<CategoryListProps> = ({
  item,
  hoveredIndex,
  onHover,
  isMobile,
  activeIndex,
}) => (
  <div
    className={classNames('flex', {
      'flex-col w-full border-b border-border-subtle': isMobile,
      'flex-col min-w-[200px] bg-gradient-to-r from-[#5250B5] to-[#224383] rounded-md p-4':
        !isMobile,
    })}
  >
    {item.categories.map((category, index) => (
      <div
        key={index}
        className={classNames(
          'text-start w-full py-3 px-5 text-label-S-semibold transition-all cursor-pointer rounded-md',
          {
            'bg-bg-base-transparent-10 text-text-inverted': hoveredIndex === index,
            'hover:bg-bg-subtle text-text-faded-inverted': hoveredIndex !== index,
          },
        )}
        onMouseEnter={() => onHover(index)}
        onClick={() => isMobile && activeIndex !== undefined}
      >
        <div className="flex justify-between items-center">
          <span>{category.title}</span>
          {isMobile && (
            <Icon
              name="arrow-right"
              className={classNames('transition-all size-5', {
                'text-text-accent': activeIndex === index,
              })}
            />
          )}
        </div>
      </div>
    ))}
  </div>
)
